export default __webpack_public_path__ + "/dist/images/graph2.e7e693f30091f207aa78b42444f7bded.png";